import { defineComponent, ref, computed, openBlock, createElementBlock, normalizeClass, createElementVNode, normalizeStyle, renderSlot, mergeProps, toHandlers, createCommentVNode, pushScopeId, popScopeId, resolveDirective, withDirectives, Fragment, renderList, toDisplayString, resolveComponent, createVNode, createTextVNode } from 'vue';
import { useField } from 'vee-validate';
import { maska } from 'maska';
import NPhone from '@team-uep/n-phone';

var script$5 = defineComponent({
  name: 'NText',
  props: {
    designType: {
      type: String,
      required: false,
      "default": 'line',
      validator: function validator(animationType) {
        return ['box', 'line'].indexOf(animationType) !== -1;
      }
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: false,
      "default": 'text'
    },
    initialValue: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: true
    },
    showIcons: {
      type: Boolean,
      "default": true
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    textColor: {
      type: String,
      "default": '#000000'
    },
    labelColor: {
      type: String,
      "default": '#000000'
    },
    borderColor: {
      type: String,
      "default": '#00A6B6'
    },
    backgroundColor: {
      type: String,
      "default": '#F3F3F3'
    },
    errorColor: {
      type: String,
      "default": '#FF3B30'
    },
    autocomplete: {
      type: String,
      "default": 'on'
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var isFocused = ref(false);

    var _useField = useField(props.name, undefined, {
      initialValue: props.initialValue,
      validateOnValueUpdate: false
    }),
        value = _useField.value,
        errorMessage = _useField.errorMessage,
        handleBlur = _useField.handleBlur,
        handleChange = _useField.handleChange,
        validate = _useField.validate,
        meta = _useField.meta;

    var isEmpty = computed(function () {
      return !value || value.length <= 0;
    });
    var isErrored = computed(function () {
      return meta.dirty && !meta.valid;
    });

    var handleValidation = function handleValidation() {
      validate().then(function (result) {
        return emit('isValid', result.valid);
      });
    }; // https://vee-validate.logaretm.com/v4/guide/composition-api/validation#handling-events


    var validationListeners = computed(function () {
      // If the field is valid or have not been validated yet, we use the lazy validation mode.
      if (!errorMessage.value) {
        return {
          blur: function blur(e) {
            handleChange(e);
            isFocused.value = false;
            handleValidation();
            emit('onBlur', true);
          },
          change: function change(e) {
            handleChange(e);
          },
          input: function input(e) {
            handleChange(e, false);
            emit('input', e.target.value);
          },
          focus: function focus() {
            isFocused.value = true;
            emit('onBlur', false);
          }
        };
      } // Aggressive validation mode.


      return {
        blur: function blur(e) {
          handleChange(e);
          isFocused.value = false;
          validate().then(function (result) {
            return emit('isValid', result.valid);
          });
          emit('onBlur', true);
        },
        change: function change(e) {
          handleChange(e);
        },
        input: function input(e) {
          handleChange(e);
          emit('input', e.target.value);
        },
        focus: function focus() {
          isFocused.value = true;
          emit('onBlur', false);
        }
      };
    });
    return {
      validationListeners: validationListeners,
      handleChange: handleChange,
      handleBlur: handleBlur,
      errorMessage: errorMessage,
      meta: meta,
      value: value,
      isErrored: isErrored,
      isFocused: isFocused,
      isEmpty: isEmpty
    };
  }
});

var _withScopeId$1 = function _withScopeId(n) {
  return pushScopeId("data-v-16ffaa8d"), n = n(), popScopeId(), n;
};

var _hoisted_1$5 = ["for"];
var _hoisted_2$5 = {
  "class": "n-input__input-container"
};
var _hoisted_3$5 = ["id", "type", "disabled", "value", "placeholder", "autocomplete"];
var _hoisted_4$4 = {
  key: 0,
  "class": "n-input__error-icon"
};
var _hoisted_5$4 = {
  xmlns: "http://www.w3.org/2000/svg",
  "class": "error-icon",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12"
};

var _hoisted_6$3 = /*#__PURE__*/_withScopeId$1(function () {
  return /*#__PURE__*/createElementVNode("defs", null, [/*#__PURE__*/createElementVNode("clipPath", {
    id: "error-path"
  }, [/*#__PURE__*/createElementVNode("path", {
    "class": "error-path",
    d: "M10.537,11.749,6,7.212,1.463,11.749A.857.857,0,0,1,.251,10.537L4.788,6,.251,1.463A.857.857,0,0,1,1.463.251L6,4.788,10.537.251a.857.857,0,0,1,1.212,1.212L7.212,6l4.537,4.537a.857.857,0,0,1-1.212,1.212Z"
  })])], -1);
});

var _hoisted_7$2 = {
  "class": "n-input__informations"
};
var _hoisted_8$2 = {
  "class": "n-input__bottom-area"
};
var _hoisted_9$1 = ["innerHTML"];
function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(["n-input n-text", "n-input-".concat(_ctx.designType)])
  }, [createElementVNode("div", {
    "class": normalizeClass(["n-input__container", {
      'valid': _ctx.meta.valid && !_ctx.isEmpty,
      'error': _ctx.isErrored,
      'active': _ctx.isFocused || !_ctx.isEmpty,
      'disabled': _ctx.disabled
    }])
  }, [createElementVNode("label", {
    "class": "n-input__label-text",
    "for": _ctx.id,
    style: normalizeStyle({
      color: _ctx.isFocused ? _ctx.borderColor : _ctx.labelColor
    })
  }, [createElementVNode("span", null, [renderSlot(_ctx.$slots, "default")])], 12, _hoisted_1$5), createElementVNode("div", _hoisted_2$5, [createElementVNode("input", mergeProps({
    id: _ctx.id,
    ref: "inputField",
    type: _ctx.type,
    disabled: _ctx.disabled,
    value: _ctx.value,
    placeholder: _ctx.placeholder,
    style: {
      'color': _ctx.textColor,
      'outline-color': _ctx.isErrored && !_ctx.isFocused ? _ctx.errorColor : _ctx.designType === 'box' ? _ctx.borderColor : 'transparent',
      'border-color': _ctx.isErrored && !_ctx.isFocused && _ctx.designType !== 'box' ? _ctx.errorColor : !_ctx.isFocused && _ctx.designType === 'box' ? _ctx.backgroundColor : _ctx.borderColor,
      'background-color': _ctx.designType === 'line' && !_ctx.isFocused ? 'transparent' : _ctx.backgroundColor
    },
    autocomplete: _ctx.autocomplete
  }, toHandlers(_ctx.validationListeners)), null, 16, _hoisted_3$5), _ctx.errorMessage ? (openBlock(), createElementBlock("span", _hoisted_4$4, [createElementVNode("span", null, [(openBlock(), createElementBlock("svg", _hoisted_5$4, [_hoisted_6$3, createElementVNode("path", {
    style: normalizeStyle({
      fill: _ctx.errorColor
    }),
    "class": "error-path",
    d: "M10.537,11.749,6,7.212,1.463,11.749A.857.857,0,0,1,.251,10.537L4.788,6,.251,1.463A.857.857,0,0,1,1.463.251L6,4.788,10.537.251a.857.857,0,0,1,1.212,1.212L7.212,6l4.537,4.537a.857.857,0,0,1-1.212,1.212Z"
  }, null, 4)]))])])) : createCommentVNode("", true)]), createElementVNode("span", _hoisted_7$2, [renderSlot(_ctx.$slots, "informations")]), createElementVNode("div", _hoisted_8$2, [createElementVNode("p", {
    "class": "n-input__error-text",
    style: normalizeStyle({
      'color': _ctx.errorColor
    })
  }, [createElementVNode("span", {
    innerHTML: _ctx.errorMessage
  }, null, 8, _hoisted_9$1)], 4)])], 2)], 2);
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$5 = ".n-input[data-v-16ffaa8d] {\n  width: 100%;\n  box-sizing: border-box;\n}\n.n-input input[type=number][data-v-16ffaa8d]::-webkit-outer-spin-button,\n.n-input input[type=number][data-v-16ffaa8d]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n.n-input input[type=number][data-v-16ffaa8d] {\n  -moz-appearance: textfield;\n}\n.n-input input[type=radio][data-v-16ffaa8d] {\n  cursor: pointer;\n}\n.n-input .n-input__field-icon[data-v-16ffaa8d], .n-input .n-input__error-icon[data-v-16ffaa8d] {\n  position: absolute;\n  right: 0.5em;\n  width: 0.8em;\n  height: 0.8em;\n  transition: all 0.3s ease;\n  text-align: center;\n  line-height: 1em;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.n-input .n-input__field-icon svg[data-v-16ffaa8d], .n-input .n-input__error-icon svg[data-v-16ffaa8d] {\n  width: 100%;\n  height: 100%;\n}\n.n-input__container[data-v-16ffaa8d] {\n  position: relative;\n  width: 100%;\n}\n.n-input__container .n-input__field-icon span[data-v-16ffaa8d],\n.n-input__container .n-input__error-icon span[data-v-16ffaa8d] {\n  opacity: 0;\n}\n.n-input__container .n-input__label-text[data-v-16ffaa8d] {\n  display: block;\n  font-size: 1em;\n  font-family: inherit;\n  margin-bottom: 0.5em;\n}\n.n-input__container .n-input__label-text span[data-v-16ffaa8d] {\n  display: block;\n}\n.n-input__container.error .n-input__error-icon span[data-v-16ffaa8d] {\n  color: #ff3b30;\n  opacity: 1;\n}\n.n-input__container.disabled[data-v-16ffaa8d] {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.n-input input[data-v-16ffaa8d] {\n  font-size: 1.1em;\n  box-shadow: none;\n  border: none;\n  font-family: inherit;\n  box-sizing: border-box;\n  transition: border-color 0.3s ease;\n  padding: 0.5em 0.7em 0.5em 0.7em;\n  width: 100%;\n  height: 50px;\n}\n.n-input input[data-v-16ffaa8d]::-moz-placeholder {\n  color: #8d8d8d;\n}\n.n-input input[data-v-16ffaa8d]:-ms-input-placeholder {\n  color: #8d8d8d;\n}\n.n-input input[data-v-16ffaa8d]::placeholder {\n  color: #8d8d8d;\n}\n.n-input.n-input-line input[data-v-16ffaa8d] {\n  border-bottom-width: 1px;\n  border-radius: 0px;\n  padding-left: 0;\n  border-bottom-style: solid;\n}\n.n-input.n-input-line input[data-v-16ffaa8d]:focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: 3px;\n}\n.n-input.n-input-line .variant-line[data-v-16ffaa8d] {\n  border-bottom-width: 1px;\n  border-radius: 0px;\n  padding-left: 0;\n  border-bottom-style: solid;\n}\n.n-input.n-input-line .variant-line[data-v-16ffaa8d]:focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: 3px;\n}\n.n-input.n-input-line .n-input__error-text[data-v-16ffaa8d] {\n  line-height: 1em;\n}\n.n-input.n-input-box input[data-v-16ffaa8d] {\n  border-radius: 3px;\n  border-width: 1px;\n  border-style: solid;\n}\n.n-input.n-input-box input[data-v-16ffaa8d]:focus {\n  outline: none;\n}\n.n-input.n-input-box .variant-box[data-v-16ffaa8d] {\n  border-bottom-width: 1px;\n  border-radius: 3px;\n  padding-left: 0;\n  border-bottom-style: solid;\n  box-shadow: none !important;\n}\n.n-input.n-input-box .variant-box[data-v-16ffaa8d]:focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: 3px;\n  box-shadow: none !important;\n}\n.n-input.n-input-box .n-input__error-text[data-v-16ffaa8d] {\n  line-height: 0.8em;\n}\n.n-input .n-input__bottom-area[data-v-16ffaa8d] {\n  min-height: 1em;\n  box-sizing: border-box;\n  margin-top: 7px;\n}\n.n-input .n-input__error-text[data-v-16ffaa8d],\n.n-input .n-input__informations[data-v-16ffaa8d] {\n  font-family: inherit;\n  font-size: 0.7em;\n  margin: 0;\n}\n.n-input input:focus + .n-input__field-icon[data-v-16ffaa8d],\n.n-input input:focus + .n-input__error-icon[data-v-16ffaa8d] {\n  display: none;\n}\n.n-input .n-input__input-container[data-v-16ffaa8d] {\n  position: relative;\n}\n.n-input .error-icon .error-path[data-v-16ffaa8d] {\n  fill: #ff3b30;\n}";
styleInject(css_248z$5);

script$5.render = render$5;
script$5.__scopeId = "data-v-16ffaa8d";

var script$4 = defineComponent({
  name: 'NMask',
  directives: {
    maska: maska
  },
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, Boolean]
    },
    placeholder: {
      type: String,
      "default": ''
    },
    showIcons: {
      type: Boolean,
      "default": true
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    forceValidate: {
      type: Boolean,
      "default": false
    },
    textColor: {
      type: String,
      "default": '#000000'
    },
    labelColor: {
      type: String,
      "default": '#000000'
    },
    borderColor: {
      type: String,
      "default": '#00A6B6'
    },
    errorColor: {
      type: String,
      "default": '#FF3B30'
    },
    mask: {
      type: String,
      required: true
    },
    type: {
      type: String,
      "default": 'number',
      required: false
    },
    designType: {
      type: String,
      required: false,
      "default": 'line',
      validator: function validator(animationType) {
        return ['box', 'line'].indexOf(animationType) !== -1;
      }
    },
    backgroundColor: {
      type: String,
      "default": '#F3F3F3'
    },
    autocomplete: {
      type: String,
      "default": 'on'
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var isFocused = ref(false);

    var _useField = useField(props.name, undefined, {
      initialValue: props.initialValue,
      validateOnValueUpdate: false
    }),
        value = _useField.value,
        errorMessage = _useField.errorMessage,
        handleBlur = _useField.handleBlur,
        handleChange = _useField.handleChange,
        meta = _useField.meta,
        validate = _useField.validate;

    var isEmpty = computed(function () {
      return !value || value.length <= 0;
    });
    var isErrored = computed(function () {
      return meta.dirty && !meta.valid;
    });

    var handleValidation = function handleValidation() {
      validate().then(function (result) {
        return emit('isValid', result.valid);
      });
    }; // https://vee-validate.logaretm.com/v4/guide/composition-api/validation#handling-events


    var validationListeners = computed(function () {
      // If the field is valid or have not been validated yet, we use the lazy validation mode.
      if (!errorMessage.value) {
        return {
          blur: function blur(e) {
            handleChange(e);
            isFocused.value = false;
            handleValidation();
            emit('onBlur', true);
          },
          change: function change(e) {
            handleChange(e);
          },
          input: function input(e) {
            handleChange(e, false);
            emit('input', e.target.value);
          },
          focus: function focus() {
            isFocused.value = true;
            emit('onBlur', false);
          }
        };
      } // Aggressive validation mode.


      return {
        blur: function blur(e) {
          handleChange(e);
          isFocused.value = false;
          handleValidation();
          emit('onBlur', true);
        },
        change: function change(e) {
          handleChange(e);
        },
        input: function input(e) {
          handleChange(e);
          emit('input', e.target.value);
        },
        focus: function focus() {
          isFocused.value = true;
          emit('onBlur', false);
        }
      };
    });
    return {
      validationListeners: validationListeners,
      handleChange: handleChange,
      handleBlur: handleBlur,
      errorMessage: errorMessage,
      meta: meta,
      value: value,
      isErrored: isErrored,
      isFocused: isFocused,
      isEmpty: isEmpty
    };
  }
});

var _withScopeId = function _withScopeId(n) {
  return pushScopeId("data-v-14249581"), n = n(), popScopeId(), n;
};

var _hoisted_1$4 = ["for"];
var _hoisted_2$4 = {
  "class": "n-input__input-container"
};
var _hoisted_3$4 = ["id", "type", "disabled", "value", "placeholder", "autocomplete"];
var _hoisted_4$3 = {
  key: 0,
  "class": "n-input__error-icon"
};
var _hoisted_5$3 = {
  xmlns: "http://www.w3.org/2000/svg",
  "class": "error-icon",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12"
};

var _hoisted_6$2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/createElementVNode("defs", null, [/*#__PURE__*/createElementVNode("clipPath", {
    id: "error-path"
  }, [/*#__PURE__*/createElementVNode("path", {
    "class": "error-path",
    d: "M10.537,11.749,6,7.212,1.463,11.749A.857.857,0,0,1,.251,10.537L4.788,6,.251,1.463A.857.857,0,0,1,1.463.251L6,4.788,10.537.251a.857.857,0,0,1,1.212,1.212L7.212,6l4.537,4.537a.857.857,0,0,1-1.212,1.212Z"
  })])], -1);
});

var _hoisted_7$1 = {
  key: 0,
  "class": "n-input__informations"
};
var _hoisted_8$1 = {
  "class": "n-input__bottom-area"
};
var _hoisted_9 = ["innerHTML"];
function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  var _directive_maska = resolveDirective("maska");

  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(["n-input n-mask", "n-input-".concat(_ctx.designType)])
  }, [createElementVNode("div", {
    "class": normalizeClass(["n-input__container", {
      'valid': _ctx.meta.valid && !_ctx.isEmpty,
      'error': _ctx.isErrored,
      'active': _ctx.isFocused || !_ctx.isEmpty,
      'disabled': _ctx.disabled
    }])
  }, [createElementVNode("label", {
    "class": "n-input__label-text",
    "for": _ctx.id,
    style: normalizeStyle({
      color: _ctx.isFocused ? _ctx.borderColor : _ctx.labelColor
    })
  }, [createElementVNode("span", null, [renderSlot(_ctx.$slots, "default")])], 12, _hoisted_1$4), createElementVNode("div", _hoisted_2$4, [withDirectives(createElementVNode("input", mergeProps({
    id: _ctx.id,
    ref: "inputField",
    type: _ctx.type,
    disabled: _ctx.disabled,
    value: _ctx.value,
    placeholder: _ctx.placeholder,
    style: {
      'color': _ctx.textColor,
      'outline-color': _ctx.isErrored && !_ctx.isFocused ? _ctx.errorColor : _ctx.designType === 'box' ? _ctx.borderColor : 'transparent',
      'border-color': _ctx.isErrored && !_ctx.isFocused && _ctx.designType !== 'box' ? _ctx.errorColor : !_ctx.isFocused && _ctx.designType === 'box' ? _ctx.backgroundColor : _ctx.borderColor,
      'background-color': _ctx.designType === 'line' && !_ctx.isFocused ? 'transparent' : _ctx.backgroundColor
    },
    autocomplete: _ctx.autocomplete
  }, toHandlers(_ctx.validationListeners)), null, 16, _hoisted_3$4), [[_directive_maska, _ctx.mask]]), _ctx.errorMessage ? (openBlock(), createElementBlock("span", _hoisted_4$3, [createElementVNode("span", null, [(openBlock(), createElementBlock("svg", _hoisted_5$3, [_hoisted_6$2, createElementVNode("path", {
    style: normalizeStyle({
      fill: _ctx.errorColor
    }),
    "class": "error-path",
    d: "M10.537,11.749,6,7.212,1.463,11.749A.857.857,0,0,1,.251,10.537L4.788,6,.251,1.463A.857.857,0,0,1,1.463.251L6,4.788,10.537.251a.857.857,0,0,1,1.212,1.212L7.212,6l4.537,4.537a.857.857,0,0,1-1.212,1.212Z"
  }, null, 4)]))])])) : createCommentVNode("", true)]), _ctx.isFocused ? (openBlock(), createElementBlock("span", _hoisted_7$1, [renderSlot(_ctx.$slots, "informations")])) : createCommentVNode("", true), createElementVNode("div", _hoisted_8$1, [createElementVNode("p", {
    "class": "n-input__error-text",
    style: normalizeStyle({
      'color': _ctx.errorColor
    })
  }, [createElementVNode("span", {
    innerHTML: _ctx.errorMessage
  }, null, 8, _hoisted_9)], 4)])], 2)], 2);
}

var css_248z$4 = ".n-input[data-v-14249581] {\n  width: 100%;\n  box-sizing: border-box;\n}\n.n-input input[type=number][data-v-14249581]::-webkit-outer-spin-button,\n.n-input input[type=number][data-v-14249581]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n.n-input input[type=number][data-v-14249581] {\n  -moz-appearance: textfield;\n}\n.n-input input[type=radio][data-v-14249581] {\n  cursor: pointer;\n}\n.n-input .n-input__field-icon[data-v-14249581], .n-input .n-input__error-icon[data-v-14249581] {\n  position: absolute;\n  right: 0.5em;\n  width: 0.8em;\n  height: 0.8em;\n  transition: all 0.3s ease;\n  text-align: center;\n  line-height: 1em;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.n-input .n-input__field-icon svg[data-v-14249581], .n-input .n-input__error-icon svg[data-v-14249581] {\n  width: 100%;\n  height: 100%;\n}\n.n-input__container[data-v-14249581] {\n  position: relative;\n  width: 100%;\n}\n.n-input__container .n-input__field-icon span[data-v-14249581],\n.n-input__container .n-input__error-icon span[data-v-14249581] {\n  opacity: 0;\n}\n.n-input__container .n-input__label-text[data-v-14249581] {\n  display: block;\n  font-size: 1em;\n  font-family: inherit;\n  margin-bottom: 0.5em;\n}\n.n-input__container .n-input__label-text span[data-v-14249581] {\n  display: block;\n}\n.n-input__container.error .n-input__error-icon span[data-v-14249581] {\n  color: #ff3b30;\n  opacity: 1;\n}\n.n-input__container.disabled[data-v-14249581] {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.n-input input[data-v-14249581] {\n  font-size: 1.1em;\n  box-shadow: none;\n  border: none;\n  font-family: inherit;\n  box-sizing: border-box;\n  transition: border-color 0.3s ease;\n  padding: 0.5em 0.7em 0.5em 0.7em;\n  width: 100%;\n  height: 50px;\n}\n.n-input input[data-v-14249581]::-moz-placeholder {\n  color: #8d8d8d;\n}\n.n-input input[data-v-14249581]:-ms-input-placeholder {\n  color: #8d8d8d;\n}\n.n-input input[data-v-14249581]::placeholder {\n  color: #8d8d8d;\n}\n.n-input.n-input-line input[data-v-14249581] {\n  border-bottom-width: 1px;\n  border-radius: 0px;\n  padding-left: 0;\n  border-bottom-style: solid;\n}\n.n-input.n-input-line input[data-v-14249581]:focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: 3px;\n}\n.n-input.n-input-line .variant-line[data-v-14249581] {\n  border-bottom-width: 1px;\n  border-radius: 0px;\n  padding-left: 0;\n  border-bottom-style: solid;\n}\n.n-input.n-input-line .variant-line[data-v-14249581]:focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: 3px;\n}\n.n-input.n-input-line .n-input__error-text[data-v-14249581] {\n  line-height: 1em;\n}\n.n-input.n-input-box input[data-v-14249581] {\n  border-radius: 3px;\n  border-width: 1px;\n  border-style: solid;\n}\n.n-input.n-input-box input[data-v-14249581]:focus {\n  outline: none;\n}\n.n-input.n-input-box .variant-box[data-v-14249581] {\n  border-bottom-width: 1px;\n  border-radius: 3px;\n  padding-left: 0;\n  border-bottom-style: solid;\n  box-shadow: none !important;\n}\n.n-input.n-input-box .variant-box[data-v-14249581]:focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: 3px;\n  box-shadow: none !important;\n}\n.n-input.n-input-box .n-input__error-text[data-v-14249581] {\n  line-height: 0.8em;\n}\n.n-input .n-input__bottom-area[data-v-14249581] {\n  min-height: 1em;\n  box-sizing: border-box;\n  margin-top: 7px;\n}\n.n-input .n-input__error-text[data-v-14249581],\n.n-input .n-input__informations[data-v-14249581] {\n  font-family: inherit;\n  font-size: 0.7em;\n  margin: 0;\n}\n.n-input input:focus + .n-input__field-icon[data-v-14249581],\n.n-input input:focus + .n-input__error-icon[data-v-14249581] {\n  display: none;\n}\n.n-input .n-input__input-container[data-v-14249581] {\n  position: relative;\n}\n.n-input .error-icon .error-path[data-v-14249581] {\n  fill: #ff3b30;\n}";
styleInject(css_248z$4);

script$4.render = render$4;
script$4.__scopeId = "data-v-14249581";

var script$3 = defineComponent({
  name: 'NCheckbox',
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      "default": ''
    },
    showIcons: {
      type: Boolean,
      "default": true
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    forceValidate: {
      type: Boolean,
      "default": false
    },
    textColor: {
      type: String,
      "default": '#000000'
    },
    labelColor: {
      type: String,
      "default": '#000000'
    },
    borderColor: {
      type: String,
      "default": '#00A6B6'
    },
    errorColor: {
      type: String,
      "default": '#FF3B30'
    },
    checkmarkColor: {
      type: String,
      "default": '#000000'
    },
    displayError: {
      type: Boolean,
      "default": true
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;

    var _useField = useField(props.name, undefined, {
      type: 'checkbox',
      checkedValue: true
    }),
        value = _useField.value,
        checked = _useField.checked,
        meta = _useField.meta,
        errorMessage = _useField.errorMessage,
        validate = _useField.validate;

    var handleCheckboxChange = function handleCheckboxChange(e) {
      value.value = e.target.checked;
      handleValidation();
    };

    var isErrored = computed(function () {
      return meta.touched && !meta.valid;
    });

    var handleValidation = function handleValidation() {
      validate().then(function (result) {
        return emit('isValid', result.valid);
      });
    };

    return {
      value: value,
      checked: checked,
      handleCheckboxChange: handleCheckboxChange,
      meta: meta,
      errorMessage: errorMessage,
      isErrored: isErrored
    };
  }
});

var _hoisted_1$3 = {
  "class": "n-input n-checkbox"
};
var _hoisted_2$3 = ["for"];
var _hoisted_3$3 = ["id", "value", "checked"];
var _hoisted_4$2 = {
  viewBox: "0 0 15 11"
};
var _hoisted_5$2 = ["stroke"];
var _hoisted_6$1 = ["for"];
var _hoisted_7 = {
  "class": "n-input__bottom-area"
};
var _hoisted_8 = ["innerHTML"];
function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$3, [createElementVNode("div", {
    ref: "inputContainer",
    "class": normalizeClass(["n-input__container", {
      'disabled': _ctx.disabled,
      'error': !!_ctx.isErrored
    }])
  }, [createElementVNode("label", {
    "class": "n-input__checkbox",
    "for": _ctx.id,
    style: normalizeStyle({
      'color': _ctx.textColor
    })
  }, [createElementVNode("input", {
    id: _ctx.id,
    ref: "inputField",
    type: "checkbox",
    value: _ctx.checked,
    checked: _ctx.checked,
    onChange: _cache[0] || (_cache[0] = function () {
      return _ctx.handleCheckboxChange && _ctx.handleCheckboxChange.apply(_ctx, arguments);
    })
  }, null, 40, _hoisted_3$3), createElementVNode("span", {
    ref: "checkmark",
    "class": "n-input__checkmark",
    style: normalizeStyle({
      'border-color': _ctx.borderColor
    })
  }, [(openBlock(), createElementBlock("svg", _hoisted_4$2, [createElementVNode("path", {
    "class": "checkmark-path",
    d: "M2.732,11.3l3.043,3.064,5.461-5.476",
    transform: "translate(0.025 -5.178)",
    stroke: _ctx.checkmarkColor
  }, null, 8, _hoisted_5$2)]))], 4)], 12, _hoisted_2$3), createElementVNode("label", {
    "for": _ctx.id,
    "class": "n-input__checkmark-label",
    style: normalizeStyle({
      color: !_ctx.isErrored ? _ctx.textColor : _ctx.errorColor
    })
  }, [renderSlot(_ctx.$slots, "default")], 12, _hoisted_6$1)], 2), createElementVNode("div", _hoisted_7, [createElementVNode("p", {
    "class": "n-input__error-text",
    style: normalizeStyle({
      'color': _ctx.errorColor
    }),
    innerHTML: _ctx.errorMessage
  }, null, 12, _hoisted_8)])]);
}

var css_248z$3 = ".n-input[data-v-43d0c76a] {\n  width: 100%;\n  box-sizing: border-box;\n}\n.n-input input[type=number][data-v-43d0c76a]::-webkit-outer-spin-button,\n.n-input input[type=number][data-v-43d0c76a]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n.n-input input[type=number][data-v-43d0c76a] {\n  -moz-appearance: textfield;\n}\n.n-input input[type=radio][data-v-43d0c76a] {\n  cursor: pointer;\n}\n.n-input .n-input__field-icon[data-v-43d0c76a], .n-input .n-input__error-icon[data-v-43d0c76a] {\n  position: absolute;\n  right: 0.5em;\n  width: 0.8em;\n  height: 0.8em;\n  transition: all 0.3s ease;\n  text-align: center;\n  line-height: 1em;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.n-input .n-input__field-icon svg[data-v-43d0c76a], .n-input .n-input__error-icon svg[data-v-43d0c76a] {\n  width: 100%;\n  height: 100%;\n}\n.n-input__container[data-v-43d0c76a] {\n  position: relative;\n  width: 100%;\n}\n.n-input__container .n-input__field-icon span[data-v-43d0c76a],\n.n-input__container .n-input__error-icon span[data-v-43d0c76a] {\n  opacity: 0;\n}\n.n-input__container .n-input__label-text[data-v-43d0c76a] {\n  display: block;\n  font-size: 1em;\n  font-family: inherit;\n  margin-bottom: 0.5em;\n}\n.n-input__container .n-input__label-text span[data-v-43d0c76a] {\n  display: block;\n}\n.n-input__container.error .n-input__error-icon span[data-v-43d0c76a] {\n  color: #ff3b30;\n  opacity: 1;\n}\n.n-input__container.disabled[data-v-43d0c76a] {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.n-input input[data-v-43d0c76a] {\n  font-size: 1.1em;\n  box-shadow: none;\n  border: none;\n  font-family: inherit;\n  box-sizing: border-box;\n  transition: border-color 0.3s ease;\n  padding: 0.5em 0.7em 0.5em 0.7em;\n  width: 100%;\n  height: 50px;\n}\n.n-input input[data-v-43d0c76a]::-moz-placeholder {\n  color: #8d8d8d;\n}\n.n-input input[data-v-43d0c76a]:-ms-input-placeholder {\n  color: #8d8d8d;\n}\n.n-input input[data-v-43d0c76a]::placeholder {\n  color: #8d8d8d;\n}\n.n-input.n-input-line input[data-v-43d0c76a] {\n  border-bottom-width: 1px;\n  border-radius: 0px;\n  padding-left: 0;\n  border-bottom-style: solid;\n}\n.n-input.n-input-line input[data-v-43d0c76a]:focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: 3px;\n}\n.n-input.n-input-line .variant-line[data-v-43d0c76a] {\n  border-bottom-width: 1px;\n  border-radius: 0px;\n  padding-left: 0;\n  border-bottom-style: solid;\n}\n.n-input.n-input-line .variant-line[data-v-43d0c76a]:focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: 3px;\n}\n.n-input.n-input-line .n-input__error-text[data-v-43d0c76a] {\n  line-height: 1em;\n}\n.n-input.n-input-box input[data-v-43d0c76a] {\n  border-radius: 3px;\n  border-width: 1px;\n  border-style: solid;\n}\n.n-input.n-input-box input[data-v-43d0c76a]:focus {\n  outline: none;\n}\n.n-input.n-input-box .variant-box[data-v-43d0c76a] {\n  border-bottom-width: 1px;\n  border-radius: 3px;\n  padding-left: 0;\n  border-bottom-style: solid;\n  box-shadow: none !important;\n}\n.n-input.n-input-box .variant-box[data-v-43d0c76a]:focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: 3px;\n  box-shadow: none !important;\n}\n.n-input.n-input-box .n-input__error-text[data-v-43d0c76a] {\n  line-height: 0.8em;\n}\n.n-input .n-input__bottom-area[data-v-43d0c76a] {\n  min-height: 1em;\n  box-sizing: border-box;\n  margin-top: 7px;\n}\n.n-input .n-input__error-text[data-v-43d0c76a],\n.n-input .n-input__informations[data-v-43d0c76a] {\n  font-family: inherit;\n  font-size: 0.7em;\n  margin: 0;\n}\n.n-input input:focus + .n-input__field-icon[data-v-43d0c76a],\n.n-input input:focus + .n-input__error-icon[data-v-43d0c76a] {\n  display: none;\n}\n.n-input .n-input__input-container[data-v-43d0c76a] {\n  position: relative;\n}\n.n-input .error-icon .error-path[data-v-43d0c76a] {\n  fill: #ff3b30;\n}\n.n-input__error-text[data-v-43d0c76a] {\n  line-height: 0.5em;\n}\n.n-input__container[data-v-43d0c76a] {\n  display: flex;\n  flex-direction: row;\n}\n.n-input__checkmark-label[data-v-43d0c76a] {\n  margin-left: 1em;\n}\n.n-input__checkbox[data-v-43d0c76a] {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: flex-start;\n  font-size: 1.1em;\n  box-shadow: none;\n  border: none;\n  font-family: inherit;\n  box-sizing: border-box;\n  cursor: pointer;\n  width: 100%;\n  max-width: 30px;\n  padding-top: 3px;\n}\n.n-input__checkbox .n-input__checkmark[data-v-43d0c76a] {\n  position: relative;\n  height: 30px;\n  min-width: 30px;\n  width: 30px;\n  border-radius: 0.375rem;\n  border: 1px solid;\n  box-sizing: border-box;\n}\n.n-input__checkbox .n-input__checkmark svg[data-v-43d0c76a] {\n  position: absolute;\n  left: 1px;\n  top: 2px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n.n-input__checkbox .n-input__checkmark svg .checkmark-path[data-v-43d0c76a] {\n  fill: transparent;\n  stroke-linecap: butt;\n}\n.n-input__checkbox input[type=checkbox][data-v-43d0c76a] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n}\n.n-input__checkbox input[type=checkbox]:checked ~ .n-input__checkmark svg[data-v-43d0c76a] {\n  opacity: 1;\n}";
styleInject(css_248z$3);

script$3.render = render$3;
script$3.__scopeId = "data-v-43d0c76a";

var script$2 = defineComponent({
  name: 'NRadios',
  props: {
    name: {
      type: String,
      required: true
    },
    values: {
      type: Object,
      "default": function _default() {
        return {};
      },
      validator: function validator(values) {
        return Object.keys(values).length > 0;
      }
    },
    selectedBackgroundColor: {
      type: String,
      "default": '#000000'
    },
    selectedColor: {
      type: String,
      "default": '#FFFFFF'
    },
    radioColor: {
      type: String,
      "default": '#000000'
    },
    backgroundColor: {
      type: String,
      "default": '#FFFFFF'
    },
    hideRadios: {
      type: Boolean,
      "default": false
    },
    hasBorder: {
      type: Boolean,
      "default": true
    },
    designType: {
      type: String,
      required: false,
      validator: function validator(animationType) {
        return ['box', 'default'].indexOf(animationType) !== -1;
      },
      "default": 'default'
    },
    labelPosition: {
      type: String,
      "default": 'side',
      validator: function validator(type) {
        return ['side', 'above'].indexOf(type) !== -1;
      }
    },
    radioLayout: {
      type: String,
      "default": 'row',
      validator: function validator(type) {
        return ['row', 'column'].indexOf(type) !== -1;
      }
    },
    borderType: {
      type: String,
      "default": 'circle',
      validator: function validator(type) {
        return ['rounded', 'circle', 'squared'].indexOf(type) !== -1;
      }
    },
    displayError: {
      type: Boolean,
      "default": true
    },
    id: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      "default": ''
    },
    showIcons: {
      type: Boolean,
      "default": true
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    forceValidate: {
      type: Boolean,
      "default": false
    },
    textColor: {
      type: String,
      "default": '#000000'
    },
    labelColor: {
      type: String,
      "default": '#000000'
    },
    borderColor: {
      type: String,
      "default": '#00A6B6'
    },
    errorColor: {
      type: String,
      "default": '#FF3B30'
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var boxStyles = computed(function () {
      return {
        "default": {
          'background-color': props.designType === 'box' ? props.backgroundColor : '',
          'border-radius': props.designType === 'box' && props.borderType === 'circle' ? '24px' : props.borderType === 'rounded' ? '4px' : '0',
          'padding': props.designType === 'box' ? '0.5em' : '0px',
          'border': props.designType === 'box' ? '1px solid' : 'none',
          'border-color': props.designType === 'box' ? props.borderColor : 'none',
          'justify-content': props.radioLayout === 'row' ? 'center' : 'flex-start'
        },
        selected: {
          'background-color': props.designType === 'box' ? props.selectedBackgroundColor : '',
          'border-radius': props.designType === 'box' && props.borderType === 'circle' ? '24px' : props.borderType === 'rounded' ? '4px' : '0',
          'padding': props.designType === 'box' ? '0.5em' : '0px',
          'border': props.designType === 'box' ? '1px solid' : 'none',
          'border-color': props.designType === 'box' ? props.selectedBackgroundColor : 'none',
          'justify-content': props.radioLayout === 'row' ? 'center' : 'flex-start'
        }
      };
    });

    var _useField = useField(props.name, undefined, {
      type: 'radio',
      checkedValue: true
    }),
        value = _useField.value,
        checked = _useField.checked,
        checkedValue = _useField.checkedValue,
        meta = _useField.meta,
        errorMessage = _useField.errorMessage,
        validate = _useField.validate;

    var handleValidation = function handleValidation() {
      validate().then(function (result) {
        return emit('isValid', result.valid);
      });
    };

    var handleRadioChange = function handleRadioChange(val) {
      value.value = val;
      handleValidation();
    };

    var isErrored = computed(function () {
      return meta.touched && !meta.valid;
    });
    return {
      boxStyles: boxStyles,
      handleRadioChange: handleRadioChange,
      value: value,
      checked: checked,
      checkedValue: checkedValue,
      meta: meta,
      errorMessage: errorMessage,
      isErrored: isErrored
    };
  }
});

var _hoisted_1$2 = {
  "class": "n-input n-radios"
};
var _hoisted_2$2 = ["for"];
var _hoisted_3$2 = ["id", "name", "value", "onChange"];
var _hoisted_4$1 = {
  "class": "n-input__bottom-area"
};
var _hoisted_5$1 = ["innerHTML"];
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$2, [createElementVNode("div", {
    ref: "inputContainer",
    "class": normalizeClass(["n-input__container", {
      'disabled': _ctx.disabled,
      'error': !!_ctx.isErrored
    }]),
    style: normalizeStyle({
      'flex-direction': _ctx.labelPosition === 'side' ? 'row' : 'column',
      'align-items': _ctx.labelPosition === 'side' ? 'center' : 'flex-start'
    })
  }, [createElementVNode("p", {
    "class": "n-radios__label-text",
    style: normalizeStyle({
      'color': _ctx.labelColor,
      'margin-bottom': _ctx.labelPosition === 'side' ? '0px' : '7px'
    })
  }, [createElementVNode("span", null, [renderSlot(_ctx.$slots, "default")])], 4), createElementVNode("div", {
    "class": "n-radios__container_flex",
    style: normalizeStyle({
      'flex-direction': _ctx.radioLayout,
      'width': _ctx.radioLayout === 'row' ? '100%' : 'auto'
    })
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.values, function (val, key) {
    return openBlock(), createElementBlock("label", {
      key: val,
      "class": normalizeClass(["n-input__radio", "n-radio-".concat(_ctx.designType)]),
      "for": "".concat(_ctx.id, "-").concat(val),
      style: normalizeStyle(val === _ctx.value ? _ctx.boxStyles.selected : _ctx.boxStyles["default"])
    }, [createElementVNode("input", {
      id: "".concat(_ctx.id, "-").concat(val),
      name: _ctx.name,
      type: "radio",
      value: val,
      onChange: function onChange($event) {
        return _ctx.handleRadioChange(val);
      }
    }, null, 40, _hoisted_3$2), !_ctx.hideRadios ? (openBlock(), createElementBlock("span", {
      key: 0,
      "class": "n-input__popout",
      style: normalizeStyle({
        'border-color': _ctx.designType === 'box' && val === _ctx.value ? _ctx.selectedColor : _ctx.radioColor
      })
    }, [createElementVNode("span", {
      "class": "n-input__popin",
      style: normalizeStyle({
        'background-color': val === _ctx.value ? _ctx.selectedColor : 'transparent'
      })
    }, null, 4)], 4)) : createCommentVNode("", true), createElementVNode("span", {
      "class": "n-input__radio-label",
      style: normalizeStyle({
        'color': _ctx.designType === 'box' && val === _ctx.value ? _ctx.selectedColor : _ctx.textColor,
        'margin-left': !_ctx.hideRadios ? '0.5em' : 0
      })
    }, toDisplayString(key), 5)], 14, _hoisted_2$2);
  }), 128))], 4)], 6), createElementVNode("div", _hoisted_4$1, [createElementVNode("p", {
    "class": "n-input__error-text",
    style: normalizeStyle({
      'color': _ctx.errorColor
    }),
    innerHTML: _ctx.errorMessage
  }, null, 12, _hoisted_5$1)])]);
}

var css_248z$2 = ".n-input[data-v-4110f4e6] {\n  width: 100%;\n  box-sizing: border-box;\n}\n.n-input input[type=number][data-v-4110f4e6]::-webkit-outer-spin-button,\n.n-input input[type=number][data-v-4110f4e6]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n.n-input input[type=number][data-v-4110f4e6] {\n  -moz-appearance: textfield;\n}\n.n-input input[type=radio][data-v-4110f4e6] {\n  cursor: pointer;\n}\n.n-input .n-input__field-icon[data-v-4110f4e6], .n-input .n-input__error-icon[data-v-4110f4e6] {\n  position: absolute;\n  right: 0.5em;\n  width: 0.8em;\n  height: 0.8em;\n  transition: all 0.3s ease;\n  text-align: center;\n  line-height: 1em;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.n-input .n-input__field-icon svg[data-v-4110f4e6], .n-input .n-input__error-icon svg[data-v-4110f4e6] {\n  width: 100%;\n  height: 100%;\n}\n.n-input__container[data-v-4110f4e6] {\n  position: relative;\n  width: 100%;\n}\n.n-input__container .n-input__field-icon span[data-v-4110f4e6],\n.n-input__container .n-input__error-icon span[data-v-4110f4e6] {\n  opacity: 0;\n}\n.n-input__container .n-input__label-text[data-v-4110f4e6] {\n  display: block;\n  font-size: 1em;\n  font-family: inherit;\n  margin-bottom: 0.5em;\n}\n.n-input__container .n-input__label-text span[data-v-4110f4e6] {\n  display: block;\n}\n.n-input__container.error .n-input__error-icon span[data-v-4110f4e6] {\n  color: #ff3b30;\n  opacity: 1;\n}\n.n-input__container.disabled[data-v-4110f4e6] {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.n-input input[data-v-4110f4e6] {\n  font-size: 1.1em;\n  box-shadow: none;\n  border: none;\n  font-family: inherit;\n  box-sizing: border-box;\n  transition: border-color 0.3s ease;\n  padding: 0.5em 0.7em 0.5em 0.7em;\n  width: 100%;\n  height: 50px;\n}\n.n-input input[data-v-4110f4e6]::-moz-placeholder {\n  color: #8d8d8d;\n}\n.n-input input[data-v-4110f4e6]:-ms-input-placeholder {\n  color: #8d8d8d;\n}\n.n-input input[data-v-4110f4e6]::placeholder {\n  color: #8d8d8d;\n}\n.n-input.n-input-line input[data-v-4110f4e6] {\n  border-bottom-width: 1px;\n  border-radius: 0px;\n  padding-left: 0;\n  border-bottom-style: solid;\n}\n.n-input.n-input-line input[data-v-4110f4e6]:focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: 3px;\n}\n.n-input.n-input-line .variant-line[data-v-4110f4e6] {\n  border-bottom-width: 1px;\n  border-radius: 0px;\n  padding-left: 0;\n  border-bottom-style: solid;\n}\n.n-input.n-input-line .variant-line[data-v-4110f4e6]:focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: 3px;\n}\n.n-input.n-input-line .n-input__error-text[data-v-4110f4e6] {\n  line-height: 1em;\n}\n.n-input.n-input-box input[data-v-4110f4e6] {\n  border-radius: 3px;\n  border-width: 1px;\n  border-style: solid;\n}\n.n-input.n-input-box input[data-v-4110f4e6]:focus {\n  outline: none;\n}\n.n-input.n-input-box .variant-box[data-v-4110f4e6] {\n  border-bottom-width: 1px;\n  border-radius: 3px;\n  padding-left: 0;\n  border-bottom-style: solid;\n  box-shadow: none !important;\n}\n.n-input.n-input-box .variant-box[data-v-4110f4e6]:focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: 3px;\n  box-shadow: none !important;\n}\n.n-input.n-input-box .n-input__error-text[data-v-4110f4e6] {\n  line-height: 0.8em;\n}\n.n-input .n-input__bottom-area[data-v-4110f4e6] {\n  min-height: 1em;\n  box-sizing: border-box;\n  margin-top: 7px;\n}\n.n-input .n-input__error-text[data-v-4110f4e6],\n.n-input .n-input__informations[data-v-4110f4e6] {\n  font-family: inherit;\n  font-size: 0.7em;\n  margin: 0;\n}\n.n-input input:focus + .n-input__field-icon[data-v-4110f4e6],\n.n-input input:focus + .n-input__error-icon[data-v-4110f4e6] {\n  display: none;\n}\n.n-input .n-input__input-container[data-v-4110f4e6] {\n  position: relative;\n}\n.n-input .error-icon .error-path[data-v-4110f4e6] {\n  fill: #ff3b30;\n}\n.n-input__error-text[data-v-4110f4e6] {\n  line-height: 0.5em;\n}\n.n-input__container[data-v-4110f4e6] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  height: 100%;\n}\n.n-radios__label-text[data-v-4110f4e6] {\n  display: inline-block;\n  margin: 0 1.5em 0 0;\n  font-size: 1em;\n  font-family: inherit;\n}\n.n-radios__label-text span[data-v-4110f4e6] {\n  display: block;\n}\n.n-radios__container_flex[data-v-4110f4e6] {\n  display: flex;\n  flex: 1;\n}\n.n-input__radio[data-v-4110f4e6] {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  font-size: 1em;\n  font-family: inherit;\n  box-shadow: none;\n  border: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  height: 48px;\n  width: 100%;\n  margin-right: 10px;\n}\n.n-input__radio .n-input__popout[data-v-4110f4e6] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 1em;\n  height: 1em;\n  border-radius: 50%;\n  border: 1px solid black;\n}\n.n-input__radio .n-input__popin[data-v-4110f4e6] {\n  width: 50%;\n  height: 50%;\n  border-radius: 50%;\n  box-sizing: border-box;\n  transition: opacity 0.3s ease;\n}\n.n-input__radio input[type=radio][data-v-4110f4e6] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n}";
styleInject(css_248z$2);

script$2.render = render$2;
script$2.__scopeId = "data-v-4110f4e6";

var unknownFlagSrc = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"480\" width=\"640\" version=\"1\"><g><path fill-rule=\"evenodd\" fill=\"#C2C1C1\" d=\"M0,0h640v480H0V0z\"/><path fill-rule=\"evenodd\" fill=\"#72706F\" d=\"M0,0h213.3v480H0V0z\"/><path fill-rule=\"evenodd\" fill=\"#969594\" d=\"M426.7,0H640v480H426.7V0z\"/></g><text transform=\"matrix(1 0 0 1 148.4385 452.708)\" fill=\"#FFF\" font-family=\"Arial-Black\" font-size=\"591.2202px\">?</text></svg>";

var script$1 = defineComponent({
  name: 'NInputsPhone',
  components: {
    NPhone: NPhone
  },
  props: {
    designType: {
      type: String,
      required: false,
      "default": 'line',
      validator: function validator(animationType) {
        return ['box', 'line'].indexOf(animationType) !== -1;
      }
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      "default": ''
    },
    showIcons: {
      type: Boolean,
      "default": true
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    textColor: {
      type: String,
      "default": '#000000'
    },
    labelColor: {
      type: String,
      "default": '#000000'
    },
    borderColor: {
      type: String,
      "default": '#00A6B6'
    },
    errorColor: {
      type: String,
      "default": '#FF3B30'
    },
    allowedNumberTypes: {
      type: Array,
      "default": function _default() {
        return ['MOBILE', 'PERSONAL_NUMBER'];
      }
    },
    backgroundColor: {
      type: String,
      "default": '#F3F3F3'
    },
    backgroundColorOpaque: {
      type: String,
      "default": ''
    },
    countries: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    dynamicallyChangeIndicator: {
      type: Boolean,
      "default": false
    },
    primaryColor: {
      type: String,
      "default": ''
    },
    showIcon: {
      type: Boolean,
      "default": false
    },
    showIndicatorSelector: {
      type: Boolean,
      "default": false
    },
    type: {
      type: String,
      "default": 'line'
    },
    unknownFlagSrc: {
      type: String,
      "default": unknownFlagSrc
    },
    autocomplete: {
      type: String,
      "default": 'on'
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var isFocused = ref(false);

    var _useField = useField(props.name, undefined, {
      validateOnValueUpdate: false
    }),
        value = _useField.value,
        errorMessage = _useField.errorMessage,
        handleChange = _useField.handleChange,
        validate = _useField.validate,
        meta = _useField.meta;

    var isErrored = computed(function () {
      return meta.touched && !meta.valid;
    });

    var handleMobileChange = function handleMobileChange(event) {
      // Ignore default browser events.
      if (event instanceof Event) {
        return;
      }

      value.value = event.inputNumber;
      validate();
      emit('isValid', event.valid);
      emit('change', event);
    };

    var validationListeners = computed(function () {
      // If the field is valid or have not been validated yet, we use the lazy validation mode.
      if (!errorMessage.value) {
        return {
          blur: function blur(e) {
            isFocused.value = false;
            emit('isValid', true);
            emit('onBlur', true);
          },
          input: function input(e) {
            emit('input', e.target.value);
          },
          focus: function focus() {
            isFocused.value = true;
            emit('onBlur', false);
          }
        };
      } // Aggressive validation mode.


      return {
        blur: function blur(e) {
          isFocused.value = false;
          emit('isValid', true);
          emit('onBlur', true);
        },
        input: function input(e) {
          emit('input', e.target.value);
        },
        focus: function focus() {
          isFocused.value = true;
          emit('onBlur', false);
        }
      };
    });
    return {
      handleMobileChange: handleMobileChange,
      value: value,
      meta: meta,
      errorMessage: errorMessage,
      isErrored: isErrored,
      validationListeners: validationListeners,
      isFocused: isFocused,
      handleChange: handleChange
    };
  }
});

var _hoisted_1$1 = ["for"];
var _hoisted_2$1 = {
  "class": "n-input__bottom-area"
};
var _hoisted_3$1 = ["innerHTML"];
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_NPhone = resolveComponent("NPhone", true);

  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(["n-input n-phone", "n-input-".concat(_ctx.designType)])
  }, [createElementVNode("div", {
    "class": normalizeClass(["n-input__container", {
      'valid': _ctx.meta.valid && !_ctx.isEmpty,
      'error': _ctx.isErrored,
      'active': _ctx.isFocused || !_ctx.isEmpty,
      'disabled': _ctx.disabled
    }])
  }, [createElementVNode("label", {
    "class": "n-input__label-text",
    "for": _ctx.id,
    style: normalizeStyle({
      color: _ctx.isFocused ? _ctx.borderColor : _ctx.labelColor
    })
  }, [createElementVNode("span", null, [renderSlot(_ctx.$slots, "default")])], 12, _hoisted_1$1), createElementVNode("div", {
    style: normalizeStyle({
      'background-color': _ctx.designType === 'line' && !_ctx.isFocused ? _ctx.backgroundColor : 'transparent',
      'outline': _ctx.designType === 'line' && !_ctx.isFocused ? 'none' : '1px solid',
      'outline-color': _ctx.isErrored && !_ctx.isFocused && _ctx.designType !== 'box' ? _ctx.errorColor : !_ctx.isFocused && _ctx.designType === 'box' ? _ctx.backgroundColor : _ctx.borderColor,
      'border-radius': '3px'
    })
  }, [createVNode(_component_NPhone, mergeProps({
    "allowed-number-types": _ctx.allowedNumberTypes,
    "background-color": _ctx.backgroundColor,
    "border-color": _ctx.isErrored ? _ctx.errorColor : _ctx.borderColor,
    countries: _ctx.countries,
    "dynamically-change-indicator": _ctx.dynamicallyChangeIndicator,
    placeholder: _ctx.placeholder,
    "primary-color": _ctx.primaryColor,
    "show-icon": _ctx.showIcon,
    "show-indicator-selector": _ctx.showIndicatorSelector,
    type: _ctx.type,
    "unknown-flag-src": _ctx.unknownFlagSrc,
    name: _ctx.name,
    "background-color-opaque": _ctx.backgroundColorOpaque,
    autocomplete: _ctx.autocomplete,
    onChange: _ctx.handleMobileChange
  }, toHandlers(_ctx.validationListeners)), null, 16, ["allowed-number-types", "background-color", "border-color", "countries", "dynamically-change-indicator", "placeholder", "primary-color", "show-icon", "show-indicator-selector", "type", "unknown-flag-src", "name", "background-color-opaque", "autocomplete", "onChange"])], 4), createElementVNode("div", _hoisted_2$1, [createElementVNode("p", {
    "class": "n-input__error-text",
    style: normalizeStyle({
      'color': _ctx.errorColor
    })
  }, [createElementVNode("span", {
    innerHTML: _ctx.errorMessage
  }, null, 8, _hoisted_3$1)], 4)])], 2)], 2);
}

var css_248z$1 = ".n-input[data-v-1ca4726d] {\n  width: 100%;\n  box-sizing: border-box;\n}\n.n-input input[type=number][data-v-1ca4726d]::-webkit-outer-spin-button,\n.n-input input[type=number][data-v-1ca4726d]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n.n-input input[type=number][data-v-1ca4726d] {\n  -moz-appearance: textfield;\n}\n.n-input input[type=radio][data-v-1ca4726d] {\n  cursor: pointer;\n}\n.n-input .n-input__field-icon[data-v-1ca4726d], .n-input .n-input__error-icon[data-v-1ca4726d] {\n  position: absolute;\n  right: 0.5em;\n  width: 0.8em;\n  height: 0.8em;\n  transition: all 0.3s ease;\n  text-align: center;\n  line-height: 1em;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.n-input .n-input__field-icon svg[data-v-1ca4726d], .n-input .n-input__error-icon svg[data-v-1ca4726d] {\n  width: 100%;\n  height: 100%;\n}\n.n-input__container[data-v-1ca4726d] {\n  position: relative;\n  width: 100%;\n}\n.n-input__container .n-input__field-icon span[data-v-1ca4726d],\n.n-input__container .n-input__error-icon span[data-v-1ca4726d] {\n  opacity: 0;\n}\n.n-input__container .n-input__label-text[data-v-1ca4726d] {\n  display: block;\n  font-size: 1em;\n  font-family: inherit;\n  margin-bottom: 0.5em;\n}\n.n-input__container .n-input__label-text span[data-v-1ca4726d] {\n  display: block;\n}\n.n-input__container.error .n-input__error-icon span[data-v-1ca4726d] {\n  color: #ff3b30;\n  opacity: 1;\n}\n.n-input__container.disabled[data-v-1ca4726d] {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.n-input input[data-v-1ca4726d] {\n  font-size: 1.1em;\n  box-shadow: none;\n  border: none;\n  font-family: inherit;\n  box-sizing: border-box;\n  transition: border-color 0.3s ease;\n  padding: 0.5em 0.7em 0.5em 0.7em;\n  width: 100%;\n  height: 50px;\n}\n.n-input input[data-v-1ca4726d]::-moz-placeholder {\n  color: #8d8d8d;\n}\n.n-input input[data-v-1ca4726d]:-ms-input-placeholder {\n  color: #8d8d8d;\n}\n.n-input input[data-v-1ca4726d]::placeholder {\n  color: #8d8d8d;\n}\n.n-input.n-input-line input[data-v-1ca4726d] {\n  border-bottom-width: 1px;\n  border-radius: 0px;\n  padding-left: 0;\n  border-bottom-style: solid;\n}\n.n-input.n-input-line input[data-v-1ca4726d]:focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: 3px;\n}\n.n-input.n-input-line .variant-line[data-v-1ca4726d] {\n  border-bottom-width: 1px;\n  border-radius: 0px;\n  padding-left: 0;\n  border-bottom-style: solid;\n}\n.n-input.n-input-line .variant-line[data-v-1ca4726d]:focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: 3px;\n}\n.n-input.n-input-line .n-input__error-text[data-v-1ca4726d] {\n  line-height: 1em;\n}\n.n-input.n-input-box input[data-v-1ca4726d] {\n  border-radius: 3px;\n  border-width: 1px;\n  border-style: solid;\n}\n.n-input.n-input-box input[data-v-1ca4726d]:focus {\n  outline: none;\n}\n.n-input.n-input-box .variant-box[data-v-1ca4726d] {\n  border-bottom-width: 1px;\n  border-radius: 3px;\n  padding-left: 0;\n  border-bottom-style: solid;\n  box-shadow: none !important;\n}\n.n-input.n-input-box .variant-box[data-v-1ca4726d]:focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: 3px;\n  box-shadow: none !important;\n}\n.n-input.n-input-box .n-input__error-text[data-v-1ca4726d] {\n  line-height: 0.8em;\n}\n.n-input .n-input__bottom-area[data-v-1ca4726d] {\n  min-height: 1em;\n  box-sizing: border-box;\n  margin-top: 7px;\n}\n.n-input .n-input__error-text[data-v-1ca4726d],\n.n-input .n-input__informations[data-v-1ca4726d] {\n  font-family: inherit;\n  font-size: 0.7em;\n  margin: 0;\n}\n.n-input input:focus + .n-input__field-icon[data-v-1ca4726d],\n.n-input input:focus + .n-input__error-icon[data-v-1ca4726d] {\n  display: none;\n}\n.n-input .n-input__input-container[data-v-1ca4726d] {\n  position: relative;\n}\n.n-input .error-icon .error-path[data-v-1ca4726d] {\n  fill: #ff3b30;\n}\n.n-input[data-v-1ca4726d] .n-input__error-text {\n  font-size: 12px !important;\n}\n.n-input[data-v-1ca4726d] input {\n  padding-left: 0 !important;\n  font-size: 19px !important;\n}\n.n-input[data-v-1ca4726d] .cross-icon {\n  width: 12px !important;\n  height: 12px !important;\n  margin: 0 8px 0 0 !important;\n}";
styleInject(css_248z$1);

script$1.render = render$1;
script$1.__scopeId = "data-v-1ca4726d";

var script = defineComponent({
  name: 'NToggle',
  props: {
    id: {
      type: String,
      "default": true
    },
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      "default": ''
    },
    showIcons: {
      type: Boolean,
      "default": true
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    forceValidate: {
      type: Boolean,
      "default": false
    },
    textColor: {
      type: String,
      "default": '#000000'
    },
    labelColor: {
      type: String,
      "default": '#000000'
    },
    borderColor: {
      type: String,
      "default": '#00A6B6'
    },
    errorColor: {
      type: String,
      "default": '#FF3B30'
    },
    untoggledColor: {
      type: String,
      "default": '#8D8D8D'
    },
    toggledColor: {
      type: String,
      "default": '#000000'
    },
    showText: {
      type: Boolean,
      "default": true
    },
    selectedText: {
      type: String,
      "default": 'Yes'
    },
    unselectedText: {
      type: String,
      "default": 'No'
    },
    height: {
      type: Number,
      "default": 15
    },
    radius: {
      type: Number,
      "default": 9999
    },
    pinColor: {
      type: String,
      "default": '#FFFFFF'
    },
    textPositionOffset: {
      type: Number,
      "default": 0
    },
    displayError: {
      type: Boolean,
      "default": true
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var textPosition = computed(function () {
      return props.height * 2.5 + 14 + props.textPositionOffset + 'px';
    });
    var containerWidth = computed(function () {
      return props.height * 2.5 + 'px';
    });
    var containerHeight = computed(function () {
      return props.height + 10 + 'px';
    });

    var _useField = useField(props.name, undefined, {
      type: 'checkbox',
      checkedValue: true
    }),
        value = _useField.value,
        checked = _useField.checked,
        meta = _useField.meta,
        errorMessage = _useField.errorMessage,
        validate = _useField.validate;

    var handleValidation = function handleValidation() {
      validate().then(function (result) {
        return emit('isValid', result.valid);
      });
    };

    var handleCheckboxChange = function handleCheckboxChange(e) {
      value.value = e.target.checked;
      handleValidation();
    };

    var isErrored = computed(function () {
      return meta.touched && !meta.valid;
    });
    return {
      textPosition: textPosition,
      containerWidth: containerWidth,
      containerHeight: containerHeight,
      value: value,
      checked: checked,
      handleCheckboxChange: handleCheckboxChange,
      meta: meta,
      errorMessage: errorMessage,
      isErrored: isErrored
    };
  }
});

var _hoisted_1 = {
  "class": "n-input n-toggle"
};
var _hoisted_2 = {
  "class": "n-input__container"
};
var _hoisted_3 = ["for"];
var _hoisted_4 = ["id", "value", "checked", "disabled"];
var _hoisted_5 = {
  "class": "n-input__bottom-area"
};
var _hoisted_6 = ["innerHTML"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [createElementVNode("label", {
    "class": "n-input__toggle",
    "for": _ctx.id,
    style: normalizeStyle({
      'color': _ctx.textColor
    })
  }, [createElementVNode("span", {
    style: normalizeStyle({
      color: _ctx.labelColor
    })
  }, [renderSlot(_ctx.$slots, "default")], 4), createElementVNode("input", {
    id: _ctx.id,
    type: "checkbox",
    value: _ctx.checked,
    checked: _ctx.checked,
    disabled: _ctx.disabled,
    onChange: _cache[0] || (_cache[0] = function () {
      return _ctx.handleCheckboxChange && _ctx.handleCheckboxChange.apply(_ctx, arguments);
    })
  }, null, 40, _hoisted_4), createElementVNode("div", {
    "class": "n-input__toggle-box",
    style: normalizeStyle({
      'background-color': _ctx.checked ? _ctx.toggledColor : _ctx.untoggledColor,
      'min-width': _ctx.containerWidth,
      'height': _ctx.containerHeight,
      'border-radius': _ctx.radius + 'px'
    })
  }, [createElementVNode("div", {
    "class": "n-input__toggle-pin",
    style: normalizeStyle({
      'width': _ctx.height + 'px',
      'height': _ctx.height + 'px',
      'background-color': _ctx.pinColor
    })
  }, null, 4), _ctx.showText ? (openBlock(), createElementBlock("span", {
    key: 0,
    "class": "yes",
    style: normalizeStyle({
      'left': _ctx.textPosition
    })
  }, [renderSlot(_ctx.$slots, "toggled", {}, function () {
    return [createTextVNode(toDisplayString(_ctx.selectedText), 1)];
  })], 4)) : createCommentVNode("", true), _ctx.showText ? (openBlock(), createElementBlock("span", {
    key: 1,
    "class": "no",
    style: normalizeStyle({
      'left': _ctx.textPosition
    })
  }, [renderSlot(_ctx.$slots, "untoggled", {}, function () {
    return [createTextVNode(toDisplayString(_ctx.unselectedText), 1)];
  })], 4)) : createCommentVNode("", true)], 4)], 12, _hoisted_3)]), createElementVNode("div", _hoisted_5, [createElementVNode("p", {
    "class": "n-input__error-text",
    style: normalizeStyle({
      'color': _ctx.errorColor
    }),
    innerHTML: _ctx.errorMessage
  }, null, 12, _hoisted_6)])]);
}

var css_248z = ".n-input[data-v-f24f3e10] {\n  width: 100%;\n  box-sizing: border-box;\n}\n.n-input input[type=number][data-v-f24f3e10]::-webkit-outer-spin-button,\n.n-input input[type=number][data-v-f24f3e10]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n.n-input input[type=number][data-v-f24f3e10] {\n  -moz-appearance: textfield;\n}\n.n-input input[type=radio][data-v-f24f3e10] {\n  cursor: pointer;\n}\n.n-input .n-input__field-icon[data-v-f24f3e10], .n-input .n-input__error-icon[data-v-f24f3e10] {\n  position: absolute;\n  right: 0.5em;\n  width: 0.8em;\n  height: 0.8em;\n  transition: all 0.3s ease;\n  text-align: center;\n  line-height: 1em;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.n-input .n-input__field-icon svg[data-v-f24f3e10], .n-input .n-input__error-icon svg[data-v-f24f3e10] {\n  width: 100%;\n  height: 100%;\n}\n.n-input__container[data-v-f24f3e10] {\n  position: relative;\n  width: 100%;\n}\n.n-input__container .n-input__field-icon span[data-v-f24f3e10],\n.n-input__container .n-input__error-icon span[data-v-f24f3e10] {\n  opacity: 0;\n}\n.n-input__container .n-input__label-text[data-v-f24f3e10] {\n  display: block;\n  font-size: 1em;\n  font-family: inherit;\n  margin-bottom: 0.5em;\n}\n.n-input__container .n-input__label-text span[data-v-f24f3e10] {\n  display: block;\n}\n.n-input__container.error .n-input__error-icon span[data-v-f24f3e10] {\n  color: #ff3b30;\n  opacity: 1;\n}\n.n-input__container.disabled[data-v-f24f3e10] {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.n-input input[data-v-f24f3e10] {\n  font-size: 1.1em;\n  box-shadow: none;\n  border: none;\n  font-family: inherit;\n  box-sizing: border-box;\n  transition: border-color 0.3s ease;\n  padding: 0.5em 0.7em 0.5em 0.7em;\n  width: 100%;\n  height: 50px;\n}\n.n-input input[data-v-f24f3e10]::-moz-placeholder {\n  color: #8d8d8d;\n}\n.n-input input[data-v-f24f3e10]:-ms-input-placeholder {\n  color: #8d8d8d;\n}\n.n-input input[data-v-f24f3e10]::placeholder {\n  color: #8d8d8d;\n}\n.n-input.n-input-line input[data-v-f24f3e10] {\n  border-bottom-width: 1px;\n  border-radius: 0px;\n  padding-left: 0;\n  border-bottom-style: solid;\n}\n.n-input.n-input-line input[data-v-f24f3e10]:focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: 3px;\n}\n.n-input.n-input-line .variant-line[data-v-f24f3e10] {\n  border-bottom-width: 1px;\n  border-radius: 0px;\n  padding-left: 0;\n  border-bottom-style: solid;\n}\n.n-input.n-input-line .variant-line[data-v-f24f3e10]:focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: 3px;\n}\n.n-input.n-input-line .n-input__error-text[data-v-f24f3e10] {\n  line-height: 1em;\n}\n.n-input.n-input-box input[data-v-f24f3e10] {\n  border-radius: 3px;\n  border-width: 1px;\n  border-style: solid;\n}\n.n-input.n-input-box input[data-v-f24f3e10]:focus {\n  outline: none;\n}\n.n-input.n-input-box .variant-box[data-v-f24f3e10] {\n  border-bottom-width: 1px;\n  border-radius: 3px;\n  padding-left: 0;\n  border-bottom-style: solid;\n  box-shadow: none !important;\n}\n.n-input.n-input-box .variant-box[data-v-f24f3e10]:focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: 3px;\n  box-shadow: none !important;\n}\n.n-input.n-input-box .n-input__error-text[data-v-f24f3e10] {\n  line-height: 0.8em;\n}\n.n-input .n-input__bottom-area[data-v-f24f3e10] {\n  min-height: 1em;\n  box-sizing: border-box;\n  margin-top: 7px;\n}\n.n-input .n-input__error-text[data-v-f24f3e10],\n.n-input .n-input__informations[data-v-f24f3e10] {\n  font-family: inherit;\n  font-size: 0.7em;\n  margin: 0;\n}\n.n-input input:focus + .n-input__field-icon[data-v-f24f3e10],\n.n-input input:focus + .n-input__error-icon[data-v-f24f3e10] {\n  display: none;\n}\n.n-input .n-input__input-container[data-v-f24f3e10] {\n  position: relative;\n}\n.n-input .error-icon .error-path[data-v-f24f3e10] {\n  fill: #ff3b30;\n}\n.n-input__toggle[data-v-f24f3e10] {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  font-size: 1em;\n  box-shadow: none;\n  border: none;\n  font-family: inherit;\n  box-sizing: border-box;\n  padding: 0.5em 0em 0.5em 0em;\n  width: 100%;\n}\n.n-input__toggle .n-input__toggle-box[data-v-f24f3e10] {\n  position: relative;\n  border-radius: 9999px;\n  display: flex;\n  padding: 0 0.2em;\n  margin-top: 1em;\n  align-items: center;\n  cursor: pointer;\n  justify-content: flex-start;\n  transition: all 0.3s ease;\n}\n.n-input__toggle .n-input__toggle-box .n-input__toggle-pin[data-v-f24f3e10] {\n  border-radius: 50%;\n  height: 100%;\n  width: 100%;\n  justify-self: flex-end;\n  transition: all 0.3s ease;\n  z-index: 698;\n}\n.n-input__toggle .n-input__toggle-box span[data-v-f24f3e10] {\n  font-family: inherit;\n  font-size: 1em;\n  position: absolute;\n  transition-delay: 0.1s;\n  transition: all 0.5s ease;\n  z-index: 697;\n}\n.n-input__toggle .n-input__toggle-box .yes[data-v-f24f3e10] {\n  position: absolute;\n  opacity: 0;\n  text-align: left;\n}\n.n-input__toggle .n-input__toggle-box .no[data-v-f24f3e10] {\n  position: absolute;\n  opacity: 1;\n  text-align: left;\n}\n.n-input__toggle input[type=checkbox][data-v-f24f3e10] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n}\n.n-input__toggle input[type=checkbox]:checked ~ .n-input__toggle-box .n-input__toggle-pin[data-v-f24f3e10] {\n  transform: translate(150%, 0);\n}\n.n-input__toggle input[type=checkbox]:checked ~ .n-input__toggle-box .yes[data-v-f24f3e10] {\n  opacity: 1;\n}\n.n-input__toggle input[type=checkbox]:checked ~ .n-input__toggle-box .no[data-v-f24f3e10] {\n  opacity: 0;\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-f24f3e10";

/**
 * Vee-Validate custom rule to ensure a string contain only characters from the
 * latin alphabet.
 *
 * @param {String} value Input value.
 * @returns {boolean}
 */
function latinString(value) {
  var regex = /^(?:(?![×÷])[ \-'aA-zZÀ-ÿ])+$/;
  return value.match(regex);
}

/**
 * Vee-Validate custom rule to make n-phone validation work properly with
 * libphonenumber-js.
 *
 * @param {String} value Input value.
 * @param {String[]} args Vee-validate rules arguments.
 * @returns {boolean}
 */
function phoneNumber(value, args) {
  return args[0] === 'true';
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function checkDateExist(year, month, day) {
  var date = new Date(year, month, day);

  if (date instanceof Date && !isNaN(date)) {
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
  }

  return false;
}

function dateRule(value) {
  var splitValue;

  if (value.match(/^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}$/)) {
    splitValue = value.split('/');

    if (splitValue[1] - 1 > 11) {
      return false;
    } else if (splitValue[0] > 31) {
      return false;
    } else {
      return checkDateExist(+splitValue[2], parseInt(splitValue[1] - 1), +splitValue[0]);
    }
  } else {
    splitValue = value.split('-');

    if (splitValue[0] - 1 > 11) {
      return false;
    } else if (splitValue[1] > 31) {
      return false;
    } else {
      return checkDateExist(+splitValue[2], +splitValue[0], parseInt(splitValue[1] - 1));
    }
  }
}
function ageMinRule(value, _ref) {
  var _ref2 = _slicedToArray(_ref, 1),
      ageMin = _ref2[0];

  ageMin = parseInt(ageMin);
  var userDate, splitValue;

  if (value.match(/^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}$/)) {
    splitValue = value.split('/');
    userDate = new Date(splitValue[2], parseInt(splitValue[1] - 1), splitValue[0]);
  } else {
    splitValue = value.split('-');
    userDate = new Date(splitValue[0], parseInt(splitValue[1] - 1), splitValue[2]);
  }

  var newYear = userDate.getFullYear() + parseInt(ageMin);
  var tempDate = new Date(newYear, userDate.getMonth(), userDate.getDate());
  return tempDate <= new Date();
}
function ageMaxRule(value, _ref3) {
  var _ref4 = _slicedToArray(_ref3, 1),
      ageMax = _ref4[0];

  ageMax = parseInt(ageMax);
  var userDate, splitValue;

  if (value.match(/^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}$/)) {
    splitValue = value.split('/');
    userDate = new Date(splitValue[2], parseInt(splitValue[1] - 1), splitValue[0]);
  } else {
    splitValue = value.split('-');
    userDate = new Date(splitValue[0], parseInt(splitValue[1] - 1), splitValue[2]);
  }

  var date = new Date();
  return userDate.getFullYear() >= date.getFullYear() - parseInt(ageMax);
}

// Components
var rules = Object.assign({}, latinString, phoneNumber, ageMaxRule, ageMinRule, dateRule); // Export all your components and rules

export { script$3 as NCheckbox, script$4 as NMask, script$1 as NPhone, script$2 as NRadios, script$5 as NText, script as NToggle, ageMaxRule, ageMinRule, dateRule, latinString as latinStringRule, phoneNumber as phoneNumberRule, rules };
